<template>
  <content-container title="交付物管理" :table-row-count="tableData.length">
    <!-- 表格数据 -->
    <el-table v-loading="loading" class="merge-table" :border="true" :scrollbar-always-on="true" :data="tableData">
      <el-table-column align="left" prop="type" label="交付物类型" :min-width="140">
        <template #default="scope">
          {{ dutyDeliverTypeConfig[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="uploadTime" label="上传日期" show-overflow-tooltip :min-width="170">
        <template #default="scope">
          {{ scope.row.uploadTime || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="remark" label="交付说明" show-overflow-tooltip :min-width="160">
        <template #default="scope">
          {{ scope.row.remark || '--' }}
        </template>
      </el-table-column>
      <el-table-column class-name="delieversList" align="left" prop="delieversList" label="交付物" :min-width="180">
        <template #default="scope">
          <div v-if="scope.row.delieversList?.length">
            <div v-for="item in scope.row.delieversList" :key="item.fileUrl" class="border-b last:border-0 pb-[10px] last:pb-0 pt-[10px] first:pt-0 px-3">
              <div class="w-[220px] text-[#1777FF] truncate  h-[20px] leading-5" @click="downloadFile(item)">
                {{ item.fileName }}
              </div>
            </div>
          </div>
          <div v-else class="ml-3">
            --
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" :min-width="120">
        <template #default="scope">
          <custom-tag :label="dutyDeliverStatusConfig[scope.row.status]" :type="dutyDeliverStatusStyle[scope.row.status]" />
        </template>
      </el-table-column>
      <el-table-column align="left" prop="updater" label="操作人" :min-width="100">
        <template #default="scope">
          {{ scope.row.updater || '--' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="props.from !== 'saas' && props.from !== 'server'"
        align="center"
        prop="actions"
        fixed="right"
        label="操作"
      >
        <template #default="scope">
          <el-link v-if="scope.row.status == EDutyDeliverStatus.NOT_UPLOADED" type="primary" :underline="false" @click="deliveryTask(scope.row)">
            上传交付物
          </el-link>       
          <el-link v-else-if="scope.row.status == EDutyDeliverStatus.REJECTED" type="primary" :underline="false" @click="deliveryTask(scope.row)">
            重新上传
          </el-link>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>

    <delivery-task-dialog :visible="deliveryTaskVisible" :row="currentRow" @close="handleCloseDeliveryTask" />
  </content-container>
</template>

<script setup lang="ts">
import { ref, PropType, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { CustomTag } from '@vue3/components';
import {
  ContentContainer,
  queryDeliverList,
} from '../../../..';
import { dutyDeliverStatusConfig, dutyDeliverStatusStyle, EDutyDeliverStatus, IDutyDeliver, dutyDeliverTypeConfig } from '@core/main/types';
import { useRoute } from 'vue-router';
import { downloadLinkFile } from '@core/api';
import DeliveryTaskDialog from './dialog/DeliveryTaskDialog.vue';

defineOptions({ personName: 'DeliveryTask' });

const props = defineProps({
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
});

const route = useRoute();

const dutyId = computed(() => Number(route.query.id));

const loading = ref(false);
const tableData = ref<IDutyDeliver[]>([]);
const deliveryTaskVisible = ref(false);
const currentRow = ref({} as IDutyDeliver);

async function fetchData() {
  loading.value = true;

  try {
    tableData.value = await queryDeliverList(dutyId.value);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function downloadFile(file: any) {
  downloadLinkFile(file.fileUrl);
}

async function deliveryTask(row: IDutyDeliver) {
  currentRow.value = row;
  deliveryTaskVisible.value = true;
}

function handleCloseDeliveryTask() {
  deliveryTaskVisible.value = false;
  fetchData();
}

fetchData();
</script>

<style lang="scss">
td.delieversList {
  .cell {
    padding:0;
  }
}
</style>
